// extracted by mini-css-extract-plugin
export var addressFields = "_oc-0";
export var animationContainer = "_oc-1";
export var footer = "_oc-2";
export var lineItems = "_oc-3";
export var modalContent = "_oc-4";
export var orderName = "_oc-5";
export var strong = "_oc-6";
export var warning = "_oc-7";